<div class="row ueberschriftRow rowSpace">
  <div class="col-12 text-center">
    <h3>Sicherheit</h3>
  </div>
</div>

<hr>

<div class="row rowSpace" *ngIf="!loading">
  <div class="col-12">
    <div class="custom-control custom-switch">
      <input type="checkbox" class="custom-control-input" id="mfaPflicht"
             [ngModel]="mfaPflicht" (ngModelChange)="saveMfaPflicht($event)" [disabled]="saving">
      <label class="custom-control-label" for="mfaPflicht">Zweiten Faktor beim Anmelden erzwingen</label>
    </div>
    <p class="small mt-2">
      Nutzer ohne zweiten Faktor werden beim Login mit Passwort aufgefordert, einen einzurichten (Code per E-Mail oder Authenticator-App).
      Die Einrichtung kann bis zu 3x aufgeschoben werden, danach ist die Anmeldung nur noch mit zweitem Faktor möglich.
      Beim Einschalten werden die Aufschübe aller Nutzer zurückgesetzt. Die Anmeldung per Passkey bleibt unverändert möglich.
    </p>
  </div>
</div>
